import 'react-datepicker/dist/react-datepicker.css';
import { Box, FormControl, Input, Select, Textarea, FormLabel, FormHelperText } from '@chakra-ui/react';

// Assets
import { formatDate } from 'services/Utils';

// Components
import { DateTimeInputIcon } from 'components/Icons/Icons';

const EditSelect = ({ 
  id, 
  options, 
  label,
  value, 
  editMode,
  isValid, 
  onChange, 
  placeholder = '',
  bg,
  mb,
  ...restProps
}) => {
  return (
    <FormControl mb={mb ?? ''} variant={editMode ? 'floating' : 'calm'} className={!editMode ? 'edit-mode' : ''}>
        <Select 
        	bg={bg ?? 'white !important' }
        	border="unset"
        	id={id} 
        	pointerEvents={editMode ? 'unset' : 'none'}
        	placeholder={placeholder} 
        	value={value} 
        	onChange={onChange} className={isValid ? 'input-valid' : 'input-invalid'}>
            { options?.map((option, index) => (
            	<option key={index} value={option.value}>{option.title}</option>
            ))}
        </Select>
        <FormLabel htmlFor={id} className={isValid ? 'input-valid' : 'input-invalid'}>{label}</FormLabel>
        <FormHelperText className={isValid ? 'hidden' : 'input-error' }>Input invalid</FormHelperText>
    </FormControl>
  );
};

export default EditSelect;






